import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Paper from '@material-ui/core/Paper'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {
  faChevronRight,
  faTimes,
  faCheck
} from '@fortawesome/fontawesome-free-solid'
import { faQuestionCircle } from '@fortawesome/fontawesome-free-regular'
import CircularProgress from '@material-ui/core/CircularProgress'

import * as configActions from '../../../actions/Config'
import * as laundryBookingActions from '../../../actions/LaundryBookings'
import * as Functions from '../../../helpers/Functions'
import * as Constants from '../../../helpers/Constants'
import * as Styles from './styles'
import * as Strings from './strings'

const AVAILABLE = 'available'
const BOOKED_BY_ME = 'booked_by_me'
const OCCUPIED = 'occupied'

class BookingSystemItems extends Component {
  state = {
    hover: { timeId: null, laundryId: null }
  }

  requestBookTime(timeId, laundryId) {
    const { config, user, data, date, offlineMode } = this.props

    this.props.showAlert(
      Strings.default.REQUEST_BOOK_TIME[config.language],
      Strings.default.REQUEST_BOOK_TIME_INFO[config.language],
      Constants.TWO_BUTTONS,
      {
        title: Strings.default.NO[config.language],
        onPress: () => {}
      },
      {
        title: Strings.default.YES[config.language],
        onPress: () => {
          const postData = {
            laundryId,
            timeId,
            date,
            maxBookings: data.laundryRules.maxBookings
          }

          this.props.tryMakeBooking(
            user.token,
            postData,
            config.language,
            (h, i, t, b) => this.props.showAlert(h, i, t, b),
            offlineMode
          )
        }
      }
    )
  }

  requestUnbookTime(id) {
    const { config, user, offlineMode } = this.props

    this.props.showAlert(
      Strings.default.REQUEST_UNBOOK_TIME[config.language],
      Strings.default.REQUEST_UNBOOK_TIME_INFO[config.language],
      Constants.TWO_BUTTONS,
      {
        title: Strings.default.NO[config.language],
        onPress: () => {}
      },
      {
        title: Strings.default.YES[config.language],
        onPress: () =>
          this.props.tryDeleteBooking(
            user.token,
            id,
            config.language,
            (h, i, t, b) => this.props.showAlert(h, i, t, b),
            offlineMode
          )
      }
    )
  }

  alertOccupiedTime(booking) {
    const { config, data } = this.props
    console.log('Debug - showApartmentInLaundry:', data.showApartmentInLaundry)
    console.log('Debug - booking:', booking)
    console.log('Debug - booking.apartment:', booking && booking.apartment)
    
    const showApartmentInfo = data.showApartmentInLaundry !== false
    const apartmentNumber = showApartmentInfo && booking && booking.apartment ? booking.apartment.number : ''
    const apartmentAddress = showApartmentInfo && booking && booking.apartment ? booking.apartment.address : ''

    console.log('Debug - showApartmentInfo:', showApartmentInfo)
    console.log('Debug - apartmentNumber:', apartmentNumber)
    console.log('Debug - apartmentAddress:', apartmentAddress)

    this.props.showAlert(
      Strings.default.OCCUPIED_ALERT_HEADER[config.language],
      apartmentNumber 
        ? Strings.default.OCCUPIED_BY_ALERT[config.language]
            .replace('{apartmentNumber}', apartmentNumber)
            .replace(apartmentAddress ? '{apartmentAddress}' : ' {apartmentAddress}', apartmentAddress ? ` ${apartmentAddress}` : '')
        : Strings.default.OCCUPIED_ALERT[config.language],
      Constants.ONE_BUTTON,
      { title: Strings.default.OK[config.language], onPress: () => {} }
    )
  }

  isCreating(timeId, laundryId) {
    const { date, laundryBookings } = this.props

    for (let i = 0; i < laundryBookings.isCreating.length; i++) {
      if (
        laundryBookings.isCreating[i].laundryId === laundryId &&
        laundryBookings.isCreating[i].timeId === timeId &&
        laundryBookings.isCreating[i].date === date
      ) {
        return true
      }
    }

    return false
  }

  render() {
    const { hover } = this.state
    const { data, date, config, user, laundryBookings } = this.props

    if (data.laundryTimes.length === 0 && user.isAdmin) {
      return (
        <p style={{ textAlign: 'center' }}>
          {Strings.default.NO_LAUNDRY_TIMES_CREATED[config.language]}
        </p>
      )
    }

    const laundryTimes = data.laundryTimes
      .filter(time => !Functions.timePassed(date, time.endTime))
      .filter(t => {
        const days = t.days.split(';')

        return days.indexOf(Constants.WEEKDAYS_JS[date.getDay()]) !== -1
      })

    if (laundryTimes.length === 0) {
      return (
        <p style={{ textAlign: 'center' }}>
          {Strings.default.NO_LAUNDRY_TIMES_TODAY[config.language]}
        </p>
      )
    }

    return laundryTimes
      .sort((o1, o2) => (o1.startTime > o2.startTime ? 1 : -1))
      .map(time => {
        const allBookings = time.bookings.filter(
          booking =>
            Functions.parseDate(date) ===
            Functions.parseDate(new Date(booking.date))
        )

        return (
          <div style={Styles.default.container} key={time.id}>
            <p>{time.startTime + '-' + time.endTime}</p>
            {data.laundries.map(laundry => {
              let status = AVAILABLE
              let onClick = () => this.requestBookTime(time.id, laundry.id)
              let loading = this.isCreating(time.id, laundry.id)
              const bookings = allBookings.filter(
                booking =>
                  booking.laundryId.toString() === laundry.id.toString()
              )

              if (
                bookings.length !== 0 &&
                bookings[0].apartment &&
                bookings[0].apartment.id === data.apartment.id
              ) {
                status = BOOKED_BY_ME
                onClick = () => this.requestUnbookTime(bookings[0].id)
                loading =
                  laundryBookings.isDeleting.indexOf(bookings[0].id) !== -1
              } else if (bookings.length !== 0) {
                status = OCCUPIED
                onClick = () => this.alertOccupiedTime(bookings[0])
                loading = false
              }

              return (
                <TimeItem
                  key={laundry.id}
                  header={
                    Strings.default.LAUNDRY[data.laundryRules.laundryType][
                      config.language
                    ] +
                    ' ' +
                    laundry.name
                  }
                  time={time.start + '-' + time.end}
                  date={date}
                  status={status}
                  language={config.language}
                  onMouseEnter={() =>
                    this.setState({
                      hover: {
                        timeId: time.id,
                        laundryId: laundry.id
                      }
                    })
                  }
                  onMouseLeave={() =>
                    this.setState({
                      hover: {
                        timeId: null,
                        laundryId: null
                      }
                    })
                  }
                  hover={
                    time.id === hover.timeId && laundry.id === hover.laundryId
                  }
                  onClick={() => onClick()}
                  loading={loading}
                />
              )
            })}
          </div>
        )
      })
  }
}

const TimeItem = ({
  header,
  status,
  language,
  onMouseEnter,
  onMouseLeave,
  hover,
  onClick,
  loading
}) => {
  let color = Constants.WHITE_LABEL.colors.primary
  let hoverColor = Constants.WHITE_LABEL.colors.primaryHover
  let text = Strings.default.AVAILABLE[language]
  let icon = faChevronRight

  if (status === BOOKED_BY_ME) {
    text = Strings.default.BOOKED_BY_ME[language]
    icon = faCheck
  } else if (status === OCCUPIED) {
    text = Strings.default.OCCUPIED[language]
    color = Constants.WHITE_LABEL.colors.warning
    hoverColor = Constants.WHITE_LABEL.colors.warningHover
    icon = faQuestionCircle
  }

  return (
    <Paper
      style={Styles.default.paperContainer}
      className={'hover'}
      onMouseEnter={() => onMouseEnter()}
      onMouseLeave={() => onMouseLeave()}
      onClick={() => (loading ? {} : onClick())}
    >
      <div style={Styles.default.innerContainer}>
        <p style={Styles.default.text}>{header}</p>
      </div>
      {loading ? (
        <CircularProgress style={{ color }} thickness={2} size={30} />
      ) : (
        <div style={Styles.default.iconContainer}>
          <p
            style={{
              ...Styles.default.iconText,
              color: hover ? hoverColor : color
            }}
          >
            {text}
          </p>
          <FontAwesomeIcon
            icon={icon}
            style={{
              ...Styles.default.icon,
              color: hover ? hoverColor : color
            }}
          />
        </div>
      )}
    </Paper>
  )
}

function mapStateToProps({ user, config, data, laundryBookings }) {
  return { user, data, config, laundryBookings }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...laundryBookingActions },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingSystemItems)



// WEBPACK FOOTER //
// ./src/components/containers/LaundryBookingItems/index.js